import React from 'react';

const OPSIYONLAR = [
  { val: 'kapali', ad: 'Kapalı', alt: 'uygulanmaz' },
  { val: 'hmk', ad: 'HMK', alt: '+1 hafta' },
  { val: 'cmk', ad: 'CMK', alt: '+3 gün' },
];

/**
 * Adli tatil rejim seçici (ana ekran) — 3 durumlu segment: Kapalı / HMK / CMK.
 * value: 'kapali'|'hmk'|'cmk'; onChange(rejim).
 */
function AdliTatilSecici({ value, onChange }) {
  return (
    <div className="app-segment w-full">
      {OPSIYONLAR.map((o) => (
        <button
          key={o.val}
          type="button"
          onClick={() => onChange(o.val)}
          className={`app-segment-item flex flex-1 flex-col items-center leading-tight !py-1.5 ${value === o.val ? 'app-segment-item-active' : ''}`}
        >
          <span className="font-semibold">{o.ad}</span>
          <span className="text-[10px] text-slate-400">{o.alt}</span>
        </button>
      ))}
    </div>
  );
}

export default AdliTatilSecici;
